import React from 'react';

import {Box, Container, Paper, Stack, Skeleton, Grid} from 'views/components';

const CaregiverProfileSkeleton = () => {
  return (
    <Stack alignItems="center" width="100%"
      sx={{
        bgcolor: (t) => t.palette.grey[50],
        minHeight: '100vh',
      }}>
      {/* Top bar / logo area */}
      <Box sx={{bgcolor: 'background.paper'}}>
        <Container maxWidth="lg" sx={{py: 1.5, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2}}>
          <Skeleton variant="rounded" width={140} height={32} />
        </Container>
      </Box>

      <Stack
        spacing={{xs: 3, sm: 4, md: 5, lg: 6}}
        sx={{
          alignItems: 'center',
          maxWidth: {xs: 350, sm: 590, md: 850, lg: 1000},
          m: 2,
        }}
      >
        {/* Profile header */}
        <Stack
          direction={{xs: 'column', sm: 'row'}}
          spacing={{xs: 1, sm: 2}}
          alignItems={{xs: 'center', sm: 'flex-start'}}
          width="100%">
          {/* Profile picture */}
          <Skeleton
            variant="circular"
            sx={{
              width: {xs: 72, sm: 96, md: 128, lg: 152},
              height: {xs: 72, sm: 96, md: 128, lg: 152},
            }}
          />
          <Box sx={{flex: 1, width: '100%'}}>
            <Stack spacing={1.2}>
              {/* Name + verified chip */}
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Skeleton variant="text" width={260} height={42} />
                <Skeleton variant="rounded" width={84} height={28} sx={{borderRadius: 10}} />
              </Stack>

              {/* Role line */}
              <Skeleton variant="text" width={220} height={24} />

              {/* Location + response time row */}
              <Stack direction="row" spacing={2}>
                <Skeleton variant="text" width={160} height={20} />
                <Skeleton variant="text" width={220} height={20} />
              </Stack>

              {/* Short bio blips */}
              <Skeleton variant="text" width={240} height={20} />
              <Skeleton variant="text" width={240} height={20} />
            </Stack>
          </Box>
        </Stack>
        {/* Services section */}
        <Stack width="100%">
          {/* Section header */}
          <Skeleton variant="text" width={220} height={36} />
          <Skeleton variant="text" width="100%" height={20} sx={{mt: 0.5}} />

          {/* Services grid */}
          <Grid container spacing={2.25} sx={{mt: 1}}>
            {Array.from({length: 10}).map((_, i) => (
              <Grid key={i} size={{xs: 12, sm: 6}}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 3,
                    height: '100%',
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="flex-start">
                    {/* Icon placeholder */}
                    <Skeleton variant="circular" width={44} height={44} />

                    {/* Title + description lines */}
                    <Box sx={{flex: 1}}>
                      <Skeleton variant="text" width="50%" height={22} />
                      <Skeleton variant="text" width="90%" height={18} />
                    </Box>
                  </Stack>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default CaregiverProfileSkeleton;
